/**
 * NavButtons Component
 *
 * Navigation buttons for prev/next/today actions.
 */

import type { ReactNode } from 'react';
import clsx from 'clsx';

export interface NavButtonsProps {
  onPrevious: () => void;
  onNext: () => void;
  onToday?: () => void;
  todayLabel?: string;
  size?: 'sm' | 'md';
  prevIcon?: ReactNode;
  nextIcon?: ReactNode;
}

export function NavButtons({
  onPrevious,
  onNext,
  onToday,
  todayLabel = 'Oggi',
  size = 'md',
  prevIcon,
  nextIcon,
}: NavButtonsProps) {
  const ChevronLeft = () => (
    <svg
      className={clsx(size === 'sm' ? 'w-3 h-3' : 'w-3.5 h-3.5')}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
    </svg>
  );
  const ChevronRightIcon = () => (
    <svg
      className={clsx(size === 'sm' ? 'w-3 h-3' : 'w-3.5 h-3.5')}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
    </svg>
  );

  return (
    <div className="flex items-center bg-surface-tertiary/50 rounded-lg overflow-hidden">
      <button
        onClick={onPrevious}
        className={clsx(
          'hover:bg-surface-hover transition-colors text-text-tertiary hover:text-text-primary',
          size === 'sm' ? 'p-1' : 'p-1.5'
        )}
      >
        {prevIcon || <ChevronLeft />}
      </button>
      {onToday && (
        <button
          onClick={onToday}
          className={clsx(
            'font-medium text-text-secondary hover:bg-surface-hover transition-colors',
            size === 'sm' ? 'px-2 py-1 text-[10px]' : 'px-2.5 py-1.5 text-[11px]'
          )}
        >
          {todayLabel}
        </button>
      )}
      <button
        onClick={onNext}
        className={clsx(
          'hover:bg-surface-hover transition-colors text-text-tertiary hover:text-text-primary',
          size === 'sm' ? 'p-1' : 'p-1.5'
        )}
      >
        {nextIcon || <ChevronRightIcon />}
      </button>
    </div>
  );
}
